import iziAddToCart from "./iziAddToCart";
import iziCanBeBound from "./iziCanBeBound";

let lastClickedElement = null;
document.addEventListener("click", function (event) {
  lastClickedElement = event.target;
});

export default async function unboundWidgetClicked(productId) {
  if (lastClickedElement && lastClickedElement.closest("#inpostpay-widget-popup")) {
    return;
  }

  const widgetPlaceholder = document.querySelector(`.izi-widget-product[data-product-id="${productId}"]`);
  let alertMessage = widgetPlaceholder?.getAttribute("data-alert-message");

  if (!alertMessage) {
      const iziButton = document.querySelector(`inpost-izi-button`);
      alertMessage = iziButton?.getAttribute("data-alert-message")
        || "An unknown error occurred.";
  }

  try {
    const canBeBound = await iziCanBeBound(productId);
    if (!canBeBound) {
      alert(alertMessage);
      throw new Error("UNDELIVERABLE_PRODUCT");
    }
    const basket_binding_api_key = await iziAddToCart(productId);
    return basket_binding_api_key;
  } catch (error) {
    throw error;
  }
}
